const features = [
  {
    icon: '🤫',
    title: 'Silent by Design',
    description:
      'Haptic feedback only. No sounds, no distractions. Designed to be your secret coping mechanism, not a meeting disruption.',
  },
  {
    icon: '👥',
    title: 'Multiplayer Mode',
    description:
      'Create a session, share the code with colleagues. See real-time "pops" when others mark words. First to bingo wins!',
  },
  {
    icon: '🎭',
    title: 'Stealth Mode',
    description:
      'Activate stealth mode and your bingo card looks like a simple checklist. Nobody needs to know your survival strategy.',
  },
  {
    icon: '🌍',
    title: 'Localized Buzzwords',
    description:
      'Word pools in English, Danish, German, Spanish, and French. Corporate jargon knows no borders.',
  },
  {
    icon: '📱',
    title: 'Play Anywhere',
    description:
      'iOS app, Android app (coming soon), or play directly in your browser. Your meeting survival kit, everywhere.',
  },
  {
    icon: '🏆',
    title: 'Quick Games',
    description:
      'No account needed to join a game. Just enter the 4-character code and you\'re in. Bingo in under 30 seconds.',
  },
]

const Features = () => {
  return (
    <section id="features" className="section bg-white">
      <div className="container-wide">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Your Meeting Survival Kit
          </h2>
          <p className="text-lg text-gray-600">
            Everything you need to transform soul-crushing meetings into a subtle game of corporate buzzword bingo.
          </p>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="p-6 rounded-2xl border border-gray-100 hover:border-bingo-200 hover:shadow-lg transition-all duration-300 bg-white"
            >
              <div className="w-12 h-12 bg-bingo-50 rounded-xl flex items-center justify-center text-2xl mb-4">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Features
